/**
 * Tests if a given item is empty. In the case of objects this means it has no
 * properties, and in the case of an array it has no elements.
 * @param objectValue The item to test for emptiness
 * @returns True if the item is empty or false otherwise
 */
export const isEmpty = (objectValue: unknown): boolean =>
  !objectValue ||
  (typeof objectValue === "object" &&
    objectValue !== null &&
    Object.entries(objectValue || {}).length === 0);
